export const SECTIONS = {
  HCP: 100,
  FILIATION_DATA: 200,
  CONSULT_REASON: 300,

  ACTUAL_CONDITION: 400,
  INTERVIEW_DISPOSITION: 405,
  ASPECT_PHYSICAL_SENSORY_MOT: 410,
  ASPECT_PHYSIOL_FUNCTIONAL: 415,
  ASPECT_COGNITIVE: 420,
  ASPECT_PERSONALITY: 425,
  ASPECT_AFFECTIVITY_MOTIV: 430,
  ASPECT_BEHAVIORAL: 435,
  ASPECT_FAMILY: 440,
  ASPECT_SOCIAL: 445,
  ASPECT_SEXUAL: 450,
  ASPECT_ACADEMIC_LABOR: 455,
  SPECIFIC_CONDITIONS: 460,

  BACKGROUND: 500,
  BACK_DEVELOPMENT: 510,
  BACK_FAMILY: 520,
  BACK_ACADEMIC_LABOR: 530,
  BACK_PSYC_PSYQ_MED: 540,
  BACK_VIOLENCE: 550,
  BACK_CRIMINAL: 560,
  BACK_RELEVANT_EVENTS: 570,
  BACK_OBSERVATIONS: 580,
  DETAILS_SYMPTOMS: 600,
  DIAGNOSIS_TREATMENT: 700,
  GENERAL_OBSERVATIONS: 800,
  TESTS: 900,
};
